module.exports = __webpack_public_path__ + "img/2023040314075953047s.3dde6149.jpg";